export function createManualResolver() {
    let resolver;
    const promise = new Promise((res) => {
        resolver = res;
    });
    return [promise, resolver];
}
//# sourceMappingURL=manual-resolver.js.map